export default __webpack_public_path__ + "static/media/Group51.e3e410fb.svg";